// ROLE BASED PERMISSION TEST PAGE

// FEATURES RELATED PAGES
import Loadable from './Loadable';
import { lazy } from 'react';

const CompanyEmailVerification = Loadable(
  lazy(() => import('pages/sessions/companyEmailVerification'))
);

const ChooseCompany = Loadable(
  lazy(() => import('pages/sessions/chooseCompany'))
);
export const PublicRoutes = [
  {
    path: '/company/confirm-company-email',
    element: <CompanyEmailVerification />
  },
  {
    path: '/choose-company',
    element: <ChooseCompany />
  }
];
